import { useState } from "react";
import DeveloperIcon from "../../../assets/svg/setting.svg";
import BodyComponent from "../../components/BodyComponent";
import SidebarLayout from "../../components/SidebarLayout";
import { DEVELOPER_TAB } from "../../resources/constantsManager";
import Developer from "./Developer";

const DeveloperCenter = () => {
  const [currentTab, setCurrentTab] = useState(DEVELOPER_TAB);

  const DeveloperMenu = [
    {
      name: "Configuration",
      icon: DeveloperIcon,
      key: DEVELOPER_TAB,
    },
  ];
  return (
    <>
      <SidebarLayout
        menu={DeveloperMenu}
        passCurrentTab={(tab) => {
          setCurrentTab(tab);
        }}
        activeTab={currentTab}
      />
      <BodyComponent>
        <Developer />
      </BodyComponent>
    </>
  );
};

export default DeveloperCenter;
